import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import React from "react"
import { Card, CardBody, Col, Label, Input, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import { Edit, SkipNext, SkipPrevious } from '@material-ui/icons';
import MaterialTable from 'material-table';
import _valid from "../../validations";
import { Asignado_Estados, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";

const columns = [
    {
        title: "Asignado por",
        field: "realizado_por.label",
        width: 200,
        sort: "asc"
    },
    {
        title: "Movimiento",
        field: "estado_nombre",
        width: 100,
        sort: "asc",
    },
    {
        title: "Codigo",
        field: "item.codigo",
        width: 100,
        sort: "asc"
    },
    {
        title: "Nombre Articulo",
        field: "item.nombre",
        width: 100,
        sort: "asc"
    },
    {
        title: "Serie Articulo",
        field: "item.serie",
        width: 100,
        sort: "asc"
    },
    {
        title: "Marca",
        field: "item.marca",
        width: 100,
        sort: "asc"
    },
    {
        title: "Descripcion",
        field: "item.descripcion",
        width: 200,
        sort: "asc"
    },
    {
        title: "Cantidad",
        field: "historial.label",
        width: 50,
        sort: "asc"
    },
    {
        title: "Asignado a",
        field: "asignado_a.label",
        width: 200,
        sort: "asc"
    },
    {
        title: "Departamento",
        field: "departamento.departamento.nombre",
        width: 100,
        sort: "asc"
    },
    {
        title: "Fecha",
        field: "fecha",
        width: 100,
        sort: "asc"
    }
];

export class vistaTrazabilidad extends React.Component {
    constructor(props) {
        super(props);
        this.apiRest = new ApiRest(props);
        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
            },
            data: []
        };
    }

    componentDidMount() {
        this.getHistorial(this.state.registro.id);
    }

    getHistorial = (id) => {
        this.apiRest.get('/trazabilidadActivo/' + id).then(resultado => {
            if (resultado.exitoso) {
                this.setState({data: resultado.data})
            } else {
                console.log('error')
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Trazabilidad" breadcrumbItem="Trazabilidad de Activos" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <MaterialTable
                                                keyField="id"
                                                title="Lista de Movimientos de un Articulo"
                                                columns={columns}
                                                data={this.state.data}
                                                options={
                                                    {
                                                        search: false,
                                                        pageSize: 2,
                                                        pageSizeOptions: [5, 10, 25],
                                                        showFirstLastPageButtons: false,
                                                    }
                                                }
                                                localization={
                                                    {
                                                        pagination: {
                                                            labelRowsSelect: 'Filas',
                                                            labelDisplayedRows: "{from}-{to} de {count}",
                                                            nextTooltip: "Siguiente Pagina",

                                                            previousTooltip: "Anterior Pagina"
                                                        }
                                                    }
                                                }
                                                icons={
                                                    {
                                                        NextPage: SkipNext,
                                                        PreviousPage: SkipPrevious
                                                    }
                                                }
                                            />
                                        </Row>
                                        <p />
                                        <Row>
                                            <Col lg={12} className="text-end">
                                                <MDBBtn className="waves-effect" color="danger" onClick={() => { this.props.history.replace('/trazabilidadArticulo') }}>
                                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                    Regresar
                                                </MDBBtn>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}